module.exports = __webpack_public_path__ + "static/edge_pistol-61415fd30283856a5ce5bafd58cb3a73.png";